import { Rocket02 } from '@untitledui/icons';

interface OnboardingSectionHeaderProps {
  remainingCount: number;
}

export function OnboardingSectionHeader({
  remainingCount,
}: OnboardingSectionHeaderProps) {
  return (
    <div className='flex items-center justify-between px-4 py-2 border-t border-primary'>
      <h2
        id='onboarding-section'
        className='flex items-center gap-2 text-sm font-semibold text-fg-primary'
      >
        <Rocket02 className='size-4 text-fg-brand-primary' />
        Onboarding
      </h2>
      <span className='text-xs text-fg-secondary'>
        {remainingCount} to complete
      </span>
    </div>
  );
}
